import { filter, orderBy } from 'lodash-es';
import { BUSINESS_PAYMENT_PREFIX, getEcardList } from 'src/clients';
import { EcardType } from 'src/models';
import { BankOptions } from 'src/pages/Disbursement/Bulk/constants';
import useSWR from 'swr';

export const useBankData = ({ excludeEwallet = false } = {}) => {
  const convertEcardToBanks = (
    ecards: EcardType[] | undefined,
  ): BankOptions[] => {
    return orderBy(
      filter(
        ecards,
        i =>
          i.vendorCode === 'dana' ||
          i.vendorCode === 'shopeepay' ||
          i.vendorCode === 'ovo' ||
          (i.cardType === 'BANK' &&
            i.vendorCode !== 'CC_DC' &&
            i.vendorCode !== 'alto' &&
            i.vendorCode !== 'mpi' &&
            !Number.isNaN(i.vendorCode)),
      ).map(bank => ({
        label: bank.vendor,
        value: bank.vendorCode,
      })),
      'label',
    );
  };

  const bankDataFetcher = () =>
    getEcardList().then(res => {
      if (res.data?.data) {
        return {
          banks: convertEcardToBanks(res.data.data.cards),
        };
      }
    });

  const { data } = useSWR(
    `${BUSINESS_PAYMENT_PREFIX}/account/bank-account/list`,
    () => bankDataFetcher(),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const banks = (data?.banks ?? []).filter(bank => {
    if (!excludeEwallet) return true;
    const isEwallet =
      bank.value === 'dana' ||
      bank.value === 'shopeepay' ||
      bank.value === 'ovo';
    return !isEwallet;
  });

  return { banks };
};
